import { Bin } from './bin';
export const BinX = (options = {}) => {
    const { thresholds } = options;
    return Bin(Object.assign(Object.assign({}, options), { thresholdsX: thresholds, groupChannels: ['color'], binChannels: ['x'] }));
};
BinX.props = {};
//# sourceMappingURL=binX.js.map